import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

export const familyMomentNoticeSchema = new schema.Entity(
  'family_moment_notices',
  {},
  {
    idAttribute: 'id',
  }
)

// ─── FamilyMomentController - "Kỷ niệm" ────────────────────────────────────

// Route::get('family-books/moment-reminder-settings/get', 'FamilyMomentController@getMomentReminderSettings');
export const familyMoment_getReminderSettings_Api = {
  backend: `Route::get('family-books/moment-reminder-settings/get', 'FamilyMomentController@getMomentReminderSettings');`,
  root: API_ROOT_URL,
  path: '/family-books/moment-reminder-settings/get',
  method: 'GET',
}
// Route::post('family-books/moment-reminder-settings/update', 'FamilyMomentController@updateMomentReminderSettings');
export const familyMoment_updateReminderSettings_Api = {
  backend: `Route::post('family-books/moment-reminder-settings/update', 'FamilyMomentController@updateMomentReminderSettings');`,
  root: API_ROOT_URL,
  path: '/family-books/moment-reminder-settings/update',
  method: 'POST',
  paramsFields: [],
}
// Route::get('family-books/my-moments', 'FamilyMomentController@getMyMoments');
export const familyMoment_getMyMoments_Api = {
  backend: `Route::get('family-books/my-moments', 'FamilyMomentController@getMyMoments');`,
  root: API_ROOT_URL,
  path: '/family-books/my-moments',
  method: 'GET',
  paramsFields: ['type', 'keyword', 'date_from', 'date_to', 'page'],
}
// Route::get('family-moment-notices/suggest-recipients', 'FamilyMomentController@suggestRecipients');
export const familyMomentNotice_suggestRecipients_Api = {
  backend: `Route::get('family-moment-notices/suggest-recipients', 'FamilyMomentController@suggestRecipients');`,
  root: API_ROOT_URL,
  path: '/family-moment-notices/suggest-recipients',
  method: 'GET',
  paramsFields: ['family_book_member_id', 'scope'],
}
// Route::post('family-moment-notices/create-and-send', 'FamilyMomentController@createAndSendNotice');
export const familyMomentNotice_createAndSend_Api = {
  backend: `Route::post('family-moment-notices/create-and-send', 'FamilyMomentController@createAndSendNotice');`,
  root: API_ROOT_URL,
  path: '/family-moment-notices/create-and-send',
  method: 'POST',
  paramsFields: [],
  schema: familyMomentNoticeSchema,
  transform: createTransform(familyMomentNoticeSchema, 'data'),
}
// Route::get('family-moment-notices/for-member/{family_book_member_id}/gets', 'FamilyMomentController@getNoticesForMember');
export const familyMomentNotice_getForMember_Api = {
  backend: `Route::get('family-moment-notices/for-member/{family_book_member_id}/gets', 'FamilyMomentController@getNoticesForMember');`,
  root: API_ROOT_URL,
  path: '/family-moment-notices/for-member/:id/gets',
  method: 'GET',
  schema: familyMomentNoticeSchema,
  transform: createListTransform(familyMomentNoticeSchema),
}
